import { Injectable } from '@angular/core';
import { ToastrService, ToastConfig } from "toastr-ng2/toastr";

@Injectable()
export class NotificationService {
    private readonly serverError: string = 'An application error has occurred! Please try again later!';
    errorConfig: ToastConfig = { positionClass: 'toast-top-full-width' };
    warningConfig: ToastConfig = { positionClass: 'toast-top-full-width', closeButton: true };

    constructor(private toastrService: ToastrService) {
    }

     showSuccess(successMessage: string, successTitle: string = '') {
         this.toastrService.success(successMessage, successTitle);
     }

    showError(errorMessage: string = this.serverError, errorTitle: string = '') {
        this.toastrService.error(errorMessage, errorTitle, this.errorConfig);
    }

     showWarning(warningMessage: string, warningTitle: string = '') {
         this.toastrService.warning(warningMessage, warningTitle, this.warningConfig);
     }
 
     showInfo(info: string) {
         this.toastrService.info(info);
     }
 
}


// WEBPACK FOOTER //
// ./src/app/core/services/notification.service.ts